// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__29cAO","noInteraction":"EventWrapper_noInteraction__fGa19"};